import { render } from "./Paths.vue?vue&type=template&id=3af05b0c&scoped=true"
import script from "./Paths.vue?vue&type=script&lang=js"
export * from "./Paths.vue?vue&type=script&lang=js"

import "./Paths.vue?vue&type=style&index=0&id=3af05b0c&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af05b0c"]])

export default __exports__